import { useQuery } from '@tanstack/react-query';

import getScheduleForReschedule from 'Api/reschedule/getScheduleForReschedule';
import { useLoader } from 'Store/loader';

import getScheduleForReschedulePayload from './model/request/getScheduleForReschedulePayload';
import getScheduleForRescheduleResponse from './model/response/getScheduleForRescheduleResponse';

const useGetScheduleForReschedule = (id, query) => {
  const { onShowLoader, onResetLoader } = useLoader();

  return useQuery({
    queryKey: ['schedules-for-reschedule', query],
    queryFn: async () => {
      onShowLoader({ variant: 'loader-primary' });

      const queryParams = getScheduleForReschedulePayload(query);

      const response = await getScheduleForReschedule(id, queryParams);

      const result = getScheduleForRescheduleResponse(response);

      onResetLoader();

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: query !== '',
  });
};

export default useGetScheduleForReschedule;
